import { render, staticRenderFns } from "./Legal_pay.vue?vue&type=template&id=953c4754&scoped=true"
import script from "./Legal_pay.vue?vue&type=script&lang=js"
export * from "./Legal_pay.vue?vue&type=script&lang=js"
import style0 from "./Legal_pay.vue?vue&type=style&index=0&id=953c4754&prod&scoped=true&lang=less"
import style1 from "./Legal_pay.vue?vue&type=style&index=1&id=953c4754&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953c4754",
  null
  
)

export default component.exports